import { skipToken, useGetCollectionQuery } from "metabase/api";
import { getUserPersonalCollectionId } from "metabase/current-user";
import { useSelector } from "metabase/redux";

/**
 * gets the personal collection for the current user
 */
export const useGetPersonalCollection = () => {
  const personalCollectionId = useSelector(getUserPersonalCollectionId);
  const response = useGetCollectionQuery(
    personalCollectionId
      ? {
          id: personalCollectionId,
        }
      : skipToken,
  );

  return response;
};
